<template>
  <div class="loan-card">
    <div class="content">
      <div class="loan-success-tip">
        <div class="home-card-notify">
          <img src="@/assets/style/home-card-notify.png" alt="" />
        </div>
        <van-swipe
          :autoplay="3000"
          :height="22"
          :show-indicators="false"
          vertical
        >
          <van-swipe-item v-for="item in loanSuccessTip" :key="item.id">{{
            item.name
          }}</van-swipe-item>
        </van-swipe>
      </div>
      <div class="home-card-constnet-wrap">
        <div class="home-card-constnet-title">最高可借额度(元)</div>
        <div class="home-card-constnet-amount ali-bold-text">{{ amountFormatter(homeData.showQuotaAmount) }}</div>
        <div class="home-card-constnet-type">
          <div
            v-for="item in homeCardType"
            :key="item.id"
            class="home-card-constnet-type-list"
          >
            <img
              class="home-card-constnet-type-list-icon"
              :src="item.icon"
              alt=""
            />
            <div class="home-card-constnet-type-list-name">{{ item.name }}</div>
          </div>
        </div>
        <div class="home-card-constnet-btn-wrap" @click="handApplyNow">
          <div class="home-card-constnet-btn">立即申请</div>
        </div>
        <div class="home-card-constnet-tip">
          <img src="@/assets/style/home-card-icon.png" alt="">
        </div>
      </div>
    </div>
    <div class="home-card-describe-wrap">
      <div v-for="item in describeList" :key="item.id" class="home-card-describe-item">
        <img :src="item.icon" alt="">
        <div class="home-card-describe-item-name">{{ item.name }}</div>
      </div>
    </div>
    <Popup
      ref="popup1"
      message="请先进行实名认证"
      confirmText="去认证"
      cancelText="取消"
      @confirm="handleConfirm"
    />
    <Popup
      ref="popup2"
      :message="`当前剩余额度 ${homeData.remainCreditAmount}元，小于最小可借金额 ${homeData.minBorrowAmount}元，每期账单还清后，可增加最大授信额度`"
      confirmText="去提额"
      cancelText="取消"
      @confirm="handleUpgrade"
    />
    <Popup
      ref="popup3"
      :message="`${blackListAd?.popContent || '资质不匹配'}`"
      :confirmText="blackListAd?.popBtnName || '去查看'"
      cancelText="取消"
      :title="blackListAd?.popTitle || '资质不匹配'"
      @confirm="handleBlackListAd"
    />
    <Popup
      ref="popup4"
      :message="`${grayListAd?.popContent?.replace('【greyDayNum】', preCheckData?.data?.greyDayNum || '')}`"
      :confirmText="grayListAd?.popBtnName || '去查看'"
      cancelText="取消"
      :title="grayListAd?.popTitle || '资质审查中'"
      @confirm="handleGrayListAd"
    />
    <Popup
      ref="popup5"
      :message="`当前已存在${
        preCheckData?.data?.onWayOrderNum || 0
      }笔在途订单，订单还清后可重新借款`"
      confirmText="去还款"
      cancelText="取消"
      title="超出订单上线"
      @confirm="handleUpgrade"
    />
    <Popup
      ref="popup6"
      message="额度不够最小借贷金额"
      confirmText="去还款"
      cancelText="取消"
      title="额度不够"
      @confirm="handleUpgrade"
    />
  </div>
</template>

<script>
import { describeList, loanSuccessTip } from "@/utils/const";
import Popup from "@/components/Popup/index.vue";
import { infoErrorCode, homeCardType } from "@/utils/const";
import { preCheck, getHomeData,getUserAllInfo } from "@/api/index";
import { amountFormatter } from "@/utils/utils";
import { setLocalStorageData } from "@/common/index.js";
import { debounce } from "@/common/index";
export default {
  components: {
    Popup,
  },
  name: "LoanCard",
  data() {
    return {
      describeList,
      loanSuccessTip,
      show: true,
      infoErrorCode,
      MESSAGE: "请先进行实名认证",
      CONFIRM_TEXT: "去认证",
      CANCEL_TEXT: "取消",
      POPUPTITLE: "提示信息",
      amountFormatter,
      homeCardType,
    };
  },
  methods: {
    //去其他产品
    handleBlackListAd() {
       if(this.blackListAd.urlType == 2) return;
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", {
          type: "10",
          url: this.blackListAd.url,
          title: this.blackListAd.name,
        });
      } else {
        window.location.href = this.blackListAd.url;
      }
    },
    handleGrayListAd() {
       if(this.grayListAd.urlType == 2) return;
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", {
          type: "10",
          url: this.grayListAd.url,
          title: this.grayListAd.name,
        });
      } else {
        window.location.href = this.grayListAd.url;
      }
    },
    handleUpgrade() {
      localStorage.setItem("actived", '2');
      this.$store.commit("setActivedTab", '2');
    },
    handleConfirm() {
      this.$router.push({
        name: "idCardBinding",
      });
    },
    handApplyNow: debounce(async function () {
      // 贷前检测
      const preCheckRes = await preCheck({});
      this.$store.commit("setPreCheckData", preCheckRes);
      setLocalStorageData("preCheckData", preCheckRes);
      const res = await getHomeData({});
      this.$store.commit("setHomeData", res.data);
      if (infoErrorCode.includes(preCheckRes.code)) {
        await this.getUserInfo();
        this.$toast("请先完成资质认证");
        this.$router.push({
          name: "idCardBinding",
        });
        return;
      } else if (preCheckRes.code == 10004 || preCheckRes.code == 10009) {
        this.$refs.popup3.showPopup();
        return;
      } else if (preCheckRes.code == 10005) {
        this.$refs.popup4.showPopup();
        return;
      } else if (preCheckRes.code == 10007) {
        this.$refs.popup2.showPopup();
        return;
      } else if (preCheckRes.code == 10008) {
        this.$refs.popup5.showPopup();
        return;
      } else if (
        this.homeData.remainCreditAmount < this.homeData.minBorrowAmount
      ) {
        this.$refs.popup2.showPopup();
        return;
      } else {
        this.$store.commit("setRouterFlag", "2");
        this.$router.push({
          name: "loan",
        });
      }
    }),
    //获取用户信息
    async getUserInfo() {
      const res = await getUserAllInfo();
      if (res.code === 2000) {
        setLocalStorageData("UserAllInfo", res.data);
      }
    },
  },
  computed: {
    homeData() {
      return this.$store.state.homeData;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    preCheckData() {
      return this.$store.state.preCheckData;
    },
    blackListAd() {
      return this.$store.state.blackListAd;
    },
    grayListAd() {
      return this.$store.state.grayListAd;
    },
  },
};
</script>

<style scoped lang="scss">
.loan-success-tip {
  height: 22px;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 11px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 11px;
  padding: 0px 7px;
  width: fit-content;
  .home-card-notify {
    height: 22px;
    display: flex;
    align-items: center;
    margin-right: 2px;
    img {
      width: 13px;
    }
  }
}
.content {
  padding: 25px;
  background-image: url("@/assets/style/home-card-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 16px;
  .home-card-constnet-wrap {
    position: relative;
    .home-card-constnet-title {
      font-weight: 400;
      font-size: 14px;
      font-style: normal;
      padding-bottom: 4px;
      padding-top: 20px;
      color: #fff;
    }
    .home-card-constnet-amount {
      font-weight: 600;
      font-size: 40px;
      color: #fff;
      font-style: normal;
    }
    .home-card-constnet-type {
      display: flex;
      align-items: center;
      margin-top: 4px;
      .home-card-constnet-type-list {
        display: flex;
        align-items: center;
        margin-right: 12px;
        .home-card-constnet-type-list-icon {
          width: 13px;
        }
        .home-card-constnet-type-list-name {
          font-size: 12px;
          color: #fff;
          margin-left: 4px;
        }
      }
    }
    .home-card-constnet-btn-wrap {
      background: #fff;
      border-radius: 50px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #F24636;
      text-align: center;
      font-style: normal;
      margin-top: 32px;
    }
    .home-card-constnet-tip{
      position: absolute;
      top: 46%;
      right: 0;
      transform: translateY(-50%);
      img{
        width: 90px;
      }
    }
  }
  .describe-list {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 16px;
    .describe-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 13px;
      font-weight: 500;
      img {
        width: 40px;
        height: 40px;
        padding-bottom: 4px;
      }
    }
  }
}
.home-card-describe-wrap{
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 76px;
  background: #FFFFFF;
  border-radius: 12px;
  margin: 16px 0px;
  .home-card-describe-item{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
    img {
      width: 34px;
      height: 34px;
      padding-bottom: 4px;
    }
  }
}
::v-deep(.van-swipe-item) {
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep(.van-swipe) {
  height: 22px;
}
</style>
